import { createSelector } from 'reselect';

export const getOrdersBusy = state => state.cards.orders.busy;
export const getOrderIds = state => state.cards.orders.allIds;
export const getOrderEntities = state => state.cards.orders.entities;
export const getOrdersById = state => state.cards.orders.entities.orders;

export const getOrders = createSelector(getOrderIds, getOrdersById, (orderIds, ordersById) =>
  orderIds.map(id => ordersById[id])
);

export const getOrderProject = (state, props) =>
  state.cards.orders.entities.projects[props.projectUUID];

export const getOrderProjectCustomization = (state, props) =>
  state.cards.orders.entities.customizations[props.customizationUUID];
export const getOrderProjectCustomizations = state => state.cards.orders.entities.customizations;

export const getMostRecentOrder = createSelector(
  getOrders,
  getOrderEntities,
  (orders, entities) => { // eslint-disable-line
    const currentOrders = [];
    orders.forEach(order => {
      // don't display orders that are cancelled
      if (order.order_status !== 'CANCELED') {
        currentOrders.push(order);
      }
    });
    const mostRecentOrder = currentOrders[0];
    if (mostRecentOrder) {
      return {
        ...mostRecentOrder,
        projects: mostRecentOrder.projects.map(uuid => entities.projects[uuid]),
      };
    }
    return undefined;
  }
);



// WEBPACK FOOTER //
// ./src/cards/selectors/ordersSelector.js